import makeClassNameComponent, {
  ClassNameComponent,
} from 'src/utils/makeClassNameComponent';

import css from './shroud.css';

// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const Shroud: ClassNameComponent = makeClassNameComponent(css.shroud);
